module.exports = __webpack_public_path__ + "static/media/bt.c59d6cd4.svg";